export default __webpack_public_path__ + "static/media/38.8c900db9.jpg";